import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import Snackbar from '@mui/material/Snackbar';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/AppBar": AppBar, "@mui/material/CssBaseline": CssBaseline, "@mui/material/GlobalStyles": GlobalStyles, "@mui/material/Toolbar": Toolbar, "@mui/material/IconButton": IconButton, "@mui/icons-material/Menu": MenuIcon, "@mui/material/Typography": Typography, "@mui/material/Button": Button, "@mui/material/Fab": Fab, "@mui/icons-material/Add": AddIcon, "@mui/material/Snackbar": Snackbar } } });
export default ClientProvider;
